import { Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

import { ErreurHTTPEnum } from '../modeles/_index';

@Injectable()
export class GestionErreurService {
  erreurHTTPReturned = new BehaviorSubject<HttpErrorResponse>(null);
  erreurHTTPReturnedChanged$ = this.erreurHTTPReturned.asObservable();

  erreurStatus = new BehaviorSubject<ErreurHTTPEnum>(null);
  erreurStatusChanged$ = this.erreurStatus.asObservable();

  constructor(private readonly _injector: Injector, private readonly _ngZone: NgZone) {
    this.erreurHTTPReturnedChanged$.subscribe(erreurHTTPReturnedHttp => {
      if (erreurHTTPReturnedHttp) {
        this.gererErreur(erreurHTTPReturnedHttp);
      }
    });
  }

  gererErreur(erreurHTTPReturnedHttp: HttpErrorResponse): void {
    if (erreurHTTPReturnedHttp.status !== 304) {
      // Fix pour remettre l'exécution du gestionnaire d'erreur dans le scope angular
      // sinon il n'interprete pas le JS
      this._ngZone.run(() => {
        this.router.navigate(['erreur']);
      });
    }
  }

  public get router(): Router {
    return this._injector.get(Router);
  }
}
